import React from 'react';
import TableOfContentsPortal from "@Features/tableOfContents/components/TableOfContentsPortal";

const CustomPermalinkPage = () => (
    <>
        {window.tableOfContents && (<TableOfContentsPortal/>)}
    </>
);

export default CustomPermalinkPage;